import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Breadcrumbs, Chip, Grid, Link, Typography } from '@mui/material';
import ChevronRightIcon from '../icons/ChevronRight';
import { CreditsUsageAlert } from './CreditsUsageAlert';
import { ProductCategory } from '../__generated__/kycTypes';
import { UserFeedbackAlert } from './UserFeedbackAlert';

export type Crumb = {
  title: string
  path: string
};

interface IProps {
  title: string
  subtitle?: string
  crumbs?: Crumb[]
  buttons?: any[]
}

const ContentHeader = ({ title, subtitle, crumbs, buttons }: IProps) => {
  const links = [];
  let last = {} as Crumb;
  if (crumbs != null) {
    for (let i = 0; i < crumbs.length - 1; i++) {
      links.push(crumbs[i]);
    }
    last = crumbs[crumbs.length - 1];
  }

  return (
        <>
            <UserFeedbackAlert
                marginBottom={2}
            />
            <CreditsUsageAlert
                marginBottom={2}
                productCategories={Object.values(ProductCategory)}
            />
            <Grid
                container
                justifyContent="space-between"
                spacing={3}
            >
                <Grid item>
                    <Box
                        pr={2}
                    >
                        <Typography
                            color="textPrimary"
                            variant="h5"
                        >
                            {title}
                        </Typography>
                        {
                            subtitle && (
                                <Chip
                                    label={subtitle}
                                    size="small"
                                    sx={{ mt: 1 }}
                                />
                            )
                        }
                    </Box>
                    <Box>
                        <Breadcrumbs
                            aria-label="breadcrumb"
                            separator={<ChevronRightIcon fontSize="small"/>}
                            sx={{ mt: 1 }}
                        >
                            {
                                links.map((it) => (
                                    <Link
                                        key={it.title}
                                        color="textPrimary"
                                        component={RouterLink}
                                        to={it.path}
                                        variant="subtitle2"
                                    >
                                        {it.title}
                                    </Link>
                                ))
                            }
                            <Typography
                                color="textSecondary"
                                variant="subtitle2"
                            >
                                {last?.title}
                            </Typography>
                        </Breadcrumbs>
                    </Box>
                </Grid>
                {
                    buttons && (
                        <Grid item>
                            <Box sx={{ display: 'flex' }}>
                                {buttons}
                            </Box>
                        </Grid>
                    )
                }
            </Grid>
        </>
  );
};

export default ContentHeader;
